/**
 * The one departure action of the recording transfer chain (`guides/application-layer.md`, "Une
 * troisième sorte d'action"). Dispatched once per transfer attempt by the handler itself, never once
 * per segment: `segmentsToTransfer` is always the size of this attempt's whole batch, never the
 * remainder after a resume skip.
 */
export type RecordingTransferStartedPayload = {
	readonly segmentsToTransfer: number;
};

export type RecordingTransferStartedAction = {
	type: 'RECORDING_TRANSFER_STARTED';
	payload: RecordingTransferStartedPayload;
	interviewId: number;
	recordingId: number;
	subjectId: number;
};

export default (
	payload: RecordingTransferStartedPayload,
	interviewId: number,
	recordingId: number,
	subjectId: number,
): RecordingTransferStartedAction => ({
	type: 'RECORDING_TRANSFER_STARTED',
	payload,
	interviewId,
	recordingId,
	subjectId,
});
